import { render, staticRenderFns } from "./simple-pop-modal.vue?vue&type=template&id=be89afea&scoped=true&"
import script from "./simple-pop-modal.vue?vue&type=script&lang=js&"
export * from "./simple-pop-modal.vue?vue&type=script&lang=js&"
import style0 from "./simple-pop-modal.vue?vue&type=style&index=0&id=be89afea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be89afea",
  null
  
)

component.options.__file = "simple-pop-modal.vue"
export default component.exports